import TableTab from "@/components/tabs/table-tab";
import { useLocale } from "@/contexts/localeContext";
import { TableContextProvider } from "@/contexts/table/TableContextProvider";
import { TranslationKeys } from "@/contexts/TranslationKeys";
import { Category } from "@/models/Category";
import OssDeviceColumns from "@/models/ColumnDefinitions/OssDeviceColumns";
import { Lookup } from "@/models/Lookup";
import LookupTypes from "@/models/LookupTypes";
import OssDeviceSearch from "@/models/search/OssDeviceSearch";
import SiteSearch from "@/models/search/SiteSearch";
import { DeleteEntityResult } from "@/models/services/DeleteEntityResult";
import { deleteOssDevice, getOssDevices } from "@/services/ossDeviceService";
import { getSiteNamesWithPagination } from "@/services/siteService";
import React, { FC } from "react";

interface OssDeviceTabProps {
    setBusy: React.Dispatch<React.SetStateAction<boolean>>,
    categories: Category[],
    setCategories: (category: Category[]) => void,
    setBusyMessage: (message: string) => void,
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const OssDeviceTab: FC<OssDeviceTabProps> = ({ setBusy, categories, setCategories, setBusyMessage, setShowModal }) => {
    const { translate } = useLocale();
    const lookup: Lookup[] = [
        {
            name: LookupTypes.site,
            values: [],
            dataMethod: getSiteNamesWithPagination,
            searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
        },
    ]

    const onDelete = (id: string): Promise<DeleteEntityResult> => {
        setBusyMessage(translate.byKey(TranslationKeys.unstallingMessage))
        setBusy(true);
        return new Promise((resolve, reject) => {
            deleteOssDevice(id)
                .then(
                    deleteResult => {
                        resolve(deleteResult);
                        const newCatergories: Category[] = categories.map((category) => {
                            return category.id === 5 ? { ...category, count: (category?.count ?? 1) - 1 } : category;
                        })
                        setCategories(newCatergories);
                        setBusy(false);
                    },
                    deleteResult => {
                        reject(deleteResult);
                        setBusy(false);
                    })
                .finally(() => {
                    setBusy(false);
                });
        });
    }

    return <TableContextProvider
        dataMethod={getOssDevices}
        tableDescriptor={OssDeviceColumns}
        searchDescriptor={OssDeviceSearch}
        useTable
        useLegend
        useSearch
        useFilter
        usePagination
        useSort
        deleteMethod={onDelete}
        lookup={lookup}
        onAddNew={() => setShowModal(true)}>
        <TableTab
            title={translate.byKey(TranslationKeys.ossDevices)}
            selectRows={false}
            rowPath={"/access-control/hardware/oss-device/"}
            cyName="ossDevice" />
    </TableContextProvider>
}

export default OssDeviceTab;